export function successMsg(response) {
  if (response.data) {
    return response.data.message;
  } else {
    return "Data Updated Successfully";
  }
}
